import { api_GET, api_POST, api_PUT, api_DELETE, api_GET_Unauthorize } from "./_api.js";


const bairro_api = {
    GetList: (prefeitura_id = "") => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Bairro/GetList/${prefeitura_id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
    GetItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Bairro/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result))
        })
        return promise;
    },
    GetItemByBairro: (bairro) => {
        const promise = new Promise((resolve, reject) => {
            api_GET_Unauthorize(`Bairro/GetItemByBairro/${bairro}`)
                .then(result => resolve(result))
                .catch(result => reject(result))
        })
        return promise;
    },
    Post: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST('Bairro', obj)
                .then(result => resolve(result))
                .catch(result => reject(result))
        })
        return promise;
    },
    Put: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT('Bairro', obj)
                .then(result => resolve(result))
                .catch(result => reject(result))
        })
        return promise;
    }
}
export default bairro_api;